import React, { Component } from 'react';
import {formatDuration} from "../Utils/Utils";
import {Link} from "react-router-dom";
import  {PAYMENT_METHOD_CREDIT_CARD} from "../Const"
import  {PAYMENT_METHOD_ALIPAY} from "../Const"
import LoadingSpinner from "../Utils/LoadingSpinner";


class AddMoney extends Component {
    state = {
        loading: true,
        dollars: 10.0,
        sec_per_dollar: 0,
    };

    componentDidMount() {
        this.props.simGps.getDevice(this.props.dev_uuid, (success, result) => {
            if ( success ) {
                this.setState (
                    {
                        sec_per_dollar: result.device.billing.sec_per_dollar,
                        loading: false,
                    }
                );
            } else {
                this.setState(
                    {
                        loading: false,
                    }
                );
            }
        } );
    }

    onDollarsChange = (evt) => {
        let val = evt.target.value;
        if( val > 1000 ){
            val = 1000;
        }else if (val < 0 ) {
            val = 0;
        }
        this.setState({ dollars: val})
    };

    render() {
        if (this.state.loading) {
            return <LoadingSpinner text="Loading device information ..."/>
        } else {
            return (
                <div>
                    <form>
                        Add money to {this.props.dev_uuid}
                        <p>
                            Pay
                            <input
                                placeholder='Dollars' value={this.state.dollars} onChange={this.onDollarsChange}
                            />
                            dollars. To add {formatDuration(this.state.dollars * this.state.sec_per_dollar)}
                            to your device
                        </p>
                        <nav>
                            <ul>
                                <li>
                                    <Link to={"/payment/" + PAYMENT_METHOD_CREDIT_CARD + "/" + this.props.dev_uuid +
                                    "/" + this.state.dollars}> Pay with credit card</Link>
                                </li>
                                <li>
                                    <Link to={"/payment/" + PAYMENT_METHOD_ALIPAY + "/" + this.props.dev_uuid +
                                    "/" + this.state.dollars}> Pay AliPay</Link>
                                </li>
                            </ul>
                        </nav>
                    </form>
                </div>
            );
        }
    }
}

export default AddMoney;
